import ChartTemplate from "@/components/chart-template";
import { ClientMetricsRow } from "@/http/api-types";
import { formatDateToMYYYY } from "@/lib/utils";
import { last12Months } from ".";
import GenericClientChart from "./clients/generic-client-chart";

type NewClientsProps = {
  audienceData: ClientMetricsRow[];
  clients: {
    newClientsCurrentMonth: number;
    newClientsLastMonth: number;
  };
};

function NewClients({ audienceData, clients }: NewClientsProps) {
  const chartData = [] as { dateTime: string; month_year: string; clients: number }[];
  const newClientNames: { [key: string]: string[] } = {};

  const monthToNewClients = audienceData.reduce(
    (acc, row) => {
      acc[row.month_year] = row.new_clients || [];
      return acc;
    },
    {} as { [key: string]: { id: number; name: string }[] },
  );

  const currentMonth = formatDateToMYYYY(new Date());
  const currentMonthNewClients = monthToNewClients[currentMonth] || [];
  chartData.push({
    month_year: currentMonth,
    dateTime: new Date(currentMonth).toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    }),
    clients: currentMonthNewClients.length,
  });
  newClientNames[currentMonth] = currentMonthNewClients.map(org => org.name);

  last12Months().forEach((month, index) => {
    const newClientsInMonth = monthToNewClients[month] || [];

    chartData.push({
      month_year: month,
      dateTime: new Date(month).toLocaleDateString("en-US", {
        month: "short",
        year: "numeric",
      }),
      clients: newClientsInMonth.length,
    });
    newClientNames[month] = newClientsInMonth.map(org => org.name);
  });

  return (
    <ChartTemplate
      timeSplittable={false}
      summaryMetric={clients.newClientsCurrentMonth.toString()}
      summaryMetricLabel="Current Month"
      title="New Clients"
      description="New clients that started in each month"
      chart={
        <GenericClientChart
          chartData={chartData.sort((a, b) => (a.month_year > b.month_year ? 1 : -1))}
          clientNames={newClientNames}
        />
      }
      table={null}
    ></ChartTemplate>
  );
}

export default NewClients;
